import { useTranslation } from 'react-i18next';
import { Image, Platform, StyleSheet, Text, View } from 'react-native';

import {
	BGCurrentDayFrameMobile,
	BGHorDividerAndTrMobile,
	BGHorDividerMobile,
	BonusGamesModalDays,
	VipBadgeFramePng,
} from '../../../../assets';
import { DayCount } from './utils';

export interface BGDayMobileProps {
	day: DayCount;
	bonus: number;
	vipBonus?: number;
	currentDay?: number;
	isSmall: boolean;
	isVip?: boolean;
}

function BGDayMobile({ day, bonus, vipBonus, currentDay, isSmall, isVip }: BGDayMobileProps) {
	const normalizedCurrentDay = currentDay != null && currentDay > 5 ? 5 : currentDay;
	const { t } = useTranslation();

	const isCurrent = normalizedCurrentDay != null && day === normalizedCurrentDay;

	const isFutureOrCurrent = normalizedCurrentDay != null ? day <= normalizedCurrentDay : false;
	const isPreviousDay = normalizedCurrentDay != null && day < normalizedCurrentDay;
	const isNative = Platform.OS !== 'web';

	return (
		<View style={styles.root}>
			<View>
				<Text style={styles.dayTitle}>
					{t('T_SITE_MODAL_BONUS_DAY', { defaultValue: 'day' })} {day}
				</Text>
			</View>
			{/* DAY IMAGE */}
			<Image
				source={BonusGamesModalDays[day]}
				resizeMode='contain'
				style={[
					styles.dayImage,
					{
						width: isSmall ? 90 : 120,
						opacity: isFutureOrCurrent ? 1 : 0.4,
					},
				]}
			/>

			{/* BONUS TEXT */}
			<View style={[styles.bonusWrap, { bottom: isSmall ? 20 : 24 }]}>
				<Text
					style={[
						styles.bonusText,
						{
							color: isFutureOrCurrent ? '#e9bf43' : '#d1d1d1',
						},
					]}
				>
					{bonus}
				</Text>
			</View>
			{isVip && (
				<View style={[styles.vipOuter, { bottom: isSmall ? 8 : 24 }]}>
					<View style={styles.vipRow}>
						<Image source={VipBadgeFramePng} style={styles.vipBadge} />
						<Text
							style={[
								styles.vipBonusText,
								{
									fontSize: isSmall ? 10 : 16,
									color: isFutureOrCurrent ? '#e9bf43' : '#d1d1d1',
								},
							]}
						>
							+ {vipBonus}
						</Text>
					</View>
				</View>
			)}

			{/* CURRENT DAY FRAME */}
			{isCurrent && (
				<Image
					source={BGCurrentDayFrameMobile}
					resizeMode='contain'
					style={[
						styles.currentFrame,
						{
							top: isVip ? -5 : -10,
						},
					]}
				/>
			)}

			<Image
				source={BGHorDividerAndTrMobile}
				resizeMode='contain'
				style={[
					styles.topDivider,
					{
						top: isVip ? -10 : -14,
						opacity: isPreviousDay ? 0 : 1,
						maxWidth: isSmall ? 150 : undefined,
					},
				]}
			/>

			{/* BOTTOM DIVIDER */}
			<Image
				source={day === 5 ? BGHorDividerMobile : BGHorDividerAndTrMobile}
				resizeMode='contain'
				style={[
					styles.bottomDivider,
					{
						bottom: day === 5 ? 2 : isNative ? -14 : -15,
						opacity: isPreviousDay ? 0 : 1,
						maxWidth: isSmall ? 140 : undefined,
					},
				]}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	root: {
		width: '100%',
		alignItems: 'center',
		position: 'relative',
		height: 60,
		marginBottom: 0,
		minHeight: 86,
	},
	dayTitle: {
		fontWeight: 'bold',
		color: '#fff',
		paddingBottom: -3,
		fontSize: 12,
		marginTop: -2,
	},
	dayImage: {
		height: 60,
		marginTop: -2,
	},
	bonusWrap: {
		position: 'absolute',
		left: 0,
		right: 0,
		alignItems: 'center',
	},
	bonusText: {
		fontSize: 16,
		fontWeight: 'bold',
	},
	vipOuter: {
		position: 'absolute',
		left: 0,
		right: 0,
		alignItems: 'center',
	},
	vipRow: {
		flexDirection: 'row',
	},
	vipBadge: {
		width: 14,
		height: 14,
	},
	vipBonusText: {
		fontWeight: 'bold',
	},
	currentFrame: {
		position: 'absolute',
		width: '100%',
		height: '100%',
	},
	topDivider: {
		position: 'absolute',
		left: 0,
		right: 0,
		aspectRatio: 5.86,
		height: 12,
		width: '100%',
	},
	bottomDivider: {
		position: 'absolute',
		left: 0,
		right: 0,
		height: 2,
		width: '100%',
	},
});

export default BGDayMobile;
